import { getToken } from "../localstorage";
import { Format } from "../entities";
import axios from "axios";
import { logger } from "@/helpers/tslog";
import { useSharePricePerformanceStore } from "@/state/sharePricePerformanceStore";

export async function fetchFormatTemplates(setCompleteFormatData) {
  const apiUrl = process.env.API_URL;
  const token = await getToken();
  let dataMap = new Map<string, string[]>();
  let primaryFormat: Format;
  try {
    const response = await axios.get(`${apiUrl}/format`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    let formatsData = response.data as Format[];
    setCompleteFormatData(formatsData);
    primaryFormat = formatsData.find((format) => format.isPrimary === true);

    formatsData.forEach(({ formatName }) => {
      const [companyName, templateName] = formatName.split("-");

      if (!companyName) return;

      if (!dataMap.has(companyName)) {
        dataMap.set(companyName, []);
      }

      dataMap.get(companyName)?.push(templateName);
    });
  } catch (e: any) {
    logger.error(e); //eslint-disable-line
  }

  return { dataMap, primaryFormat };
}

export async function fetchFormatTemplate(id: string): Promise<Format | null> {
  const apiUrl = process.env.API_URL;
  const token = await getToken();

  try {
    const response = await axios.get(`${apiUrl}/format-without-images`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { id },
    });
    const data = response.data as Format;
    return data; // return for the component to use
  } catch (e: any) {
    logger.error(e); //eslint-disable-line
    return null;
  }
}

export async function handleFetchTemplate(id: string) {
  const data = await fetchFormatTemplate(id);
  if (data) {
    const formatData = JSON.parse(data.formatData);
    useSharePricePerformanceStore.getState().setMetaData({
      fontColor: formatData.fontColor,
      fontStyle: formatData.fontStyle,
      fontSize: formatData.fontSize,
    });
  }
}

export async function fetchPrimaryTemplateWithImage(formatId?: string): Promise<Format | null> {
  const apiUrl = process.env.API_URL;
  const token = await getToken();

  try {
    const response = await axios.get(`${apiUrl}/format/primary-format`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { id: formatId },
    });

    if (response.data.success || response.data) {
      return response.data.data || (response.data as Format);
    } else {
      logger.error("Failed to fetch template with image:", response.data);
      return null;
    }
  } catch (error: any) {
    logger.error("Error fetching template with image:", error);
    return null;
  }
}
